import { throwError as observableThrowError } from "rxjs"

import { Injectable } from "@angular/core"
import { Jsonp } from "@angular/http"
import { catchError, map } from "rxjs/operators"

@Injectable({
    providedIn: "root",
})
export class URSService {
    constructor(private jsonp: Jsonp) {}

    public evaluateURSRestriction(ursURL: string) {
        return this.jsonp
            .request(`${ursURL}?format=jsonp&callback=JSONP_CALLBACK`)
            .pipe(
                map((res: any) => {
                    const ursObj = res.json()
                    if (ursObj.status === "ok") {
                        return { url: ursObj.url }
                    } else {
                        return { error: ursObj.http_code }
                    }
                }),
                catchError((error) => observableThrowError(error))
            )
    }
}
